import { z } from 'zod';
/**
 * Building blocks shared by every domain schema in this package.
 *
 * Identifiers are UUIDs generated by the database. Timestamps cross the wire as
 * ISO-8601 strings, never as `Date` instances: these shapes describe JSON
 * payloads, and a `Date` would be a lie about what arrives at the other end.
 * Convert to `Date` at the point of use, not in the contract.
 */
export const idSchema = z.uuid();
export const isoTimestampSchema = z.iso.datetime();
//# sourceMappingURL=primitives.js.map